import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/forgot-password/page.tsx");
